export default __webpack_public_path__ + "static/media/cog.aaae8fd8.svg";